import { Theme } from '@material-ui/core/styles';

export const Pickers = (theme: Theme): unknown => ({});
